<template>
  <div id="stepTwo">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <h2>Student Volunteer Questions</h2>
      <h3>Question 1</h3>
      <b-form-group  label-for="essay1">
        <div class="row">
          <div class="col col-md-8">
            <h6>We’d love to hear about the motivations that support your interest in becoming a student volunteer. What excites you most about this opportunity, and what drives you to contribute to the organization in this way? Share how your unique strengths, skills, and experiences would make you an excellent fit for this role.</h6>
            <b-form-textarea id="essay1" @input="wordCount('essay1', 300)" v-model="essay1" :rows="10" :max-rows="100"/>
            <p :class="essay1WordLimitClass">{{ essay1WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <h3>Question 2</h3>
      <b-form-group label-for="essay2">
        <div class="row">
          <div class="col col-md-8">
            <h6>SIGGRAPH is a vibrant and diverse community that brings together professionals, students, and enthusiasts from all over the world. Tell about a time when you connected with people from a background different from your own, and how the experience helped you grow or broaden your perspective. Share any meaningful insights or lessons you took away, as well as how it may have influenced your understanding, empathy, or approach to working with others.</h6>
            <b-form-textarea id="essay2" @input="wordCount('essay2', 300)" v-model="essay2" :rows="10" :max-rows="100"/>
            <p :class="essay2WordLimitClass">{{ essay2WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <h3>Question 3</h3>
      <b-form-group label-for="essay3">
        <div class="row">
          <div class="col col-md-8">
            <h6>Conference environments can sometimes be unpredictable, and it’s not uncommon to face unexpected or challenging situations. Please share about a time when you encountered a stressful or surprising situation involving others, where you took it upon yourself to step in and resolve the issue. What actions did you decide to take, and how did the situation ultimately play out? Reflecting on this experience, what lessons did you gain, and how would you use those insights to navigate similar challenges in the future?</h6>
            <b-form-textarea id="essay3" @input="wordCount('essay3', 300)" v-model="essay3" :rows="10" :max-rows="100"/>
            <p :class="essay3WordLimitClass">{{ essay3WordCount }}</p>
          </div>
        </div>
      </b-form-group>
      <b-form-group>
        <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-sm float-sm-left" @click="previousStep"><div>Previous Step</div></button>
        <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-sm float-sm-right" @click="nextStep"><div>Save and Continue</div></button>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import router from '@/router'
import moment from 'moment'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepTwo',
  data () {
    return {
      essay1WordCount: '300 words remaining',
      essay1WordLimitClass: 'under-limit',
      essay2WordCount: '300 words remaining',
      essay2WordLimitClass: 'under-limit',
      essay3WordCount: '300 words remaining',
      essay3WordLimitClass: 'under-limit',
      disabled: false
    }
  },
  computed: {
    ...generateVuexSetters([
      'essay1',
      'essay2',
      'essay3'
    ]),
    ...mapState('application', ['isLoaded', 'isLoading'])
  },
  methods: {
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    nextStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 3)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepThree' })
          this.disabled = true
        }).catch(err => {
          console.log(err.message)
          this.disabled = true
        })
      }
    },
    previousStep (e) {
      e.preventDefault()
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.commit('application/updateStep', 1)
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepOne' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.$store.dispatch('application/save')
        } else if (this.$store.state.application.step !== 2) {
          router.push('/application/' + this.$store.state.application.step.toString())
        }
      })
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('essay1', 300)
    this.wordCount('essay2', 300)
    this.wordCount('essay3', 300)
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/application/StepTwo.vue